'use strict'

var config = require('../config')

module.exports = function (options) {

  options = options || {}

  var memcached = null

  try {
    var Memcached = require('memcached')

    memcached = new Memcached(options.servers || config.servers, {
      poolSize: options.poolSize || config.poolSize,
      timeout: options.timeout || config.timeout,
      retries: options.retries || config.retries,
      failures: options.failures || config.failures,
      namespace: (options.namespace === undefined ? config.namespace : options.namespace)
    })
  } catch (e) {
    console.log('Memcached error: ', e)
  }

  return memcached
}



// WEBPACK FOOTER //
// ./lib/http-memoizr/src/lib/memcached.js